import { ApolloError } from 'apollo-client';
import { GraphQLError } from 'graphql';

import type { BadStatusError } from '@confluence/network';

export const convertToApolloError = (error: Error | BadStatusError): ApolloError => {
	const message = error.message || 'Unknown error';
	const status = 'response' in error ? error.response?.status : undefined;

	// TODO: Replace this with ApolloError shim and remove apollo-client import from package
	return new ApolloError({
		graphQLErrors: [createGraphQLError({ message, status, originalError: error })],
		networkError: error,
	});
};

const createGraphQLError = ({
	message,
	status,
	originalError,
}: {
	message: string;
	status: number | undefined;
	originalError: Error;
}) => {
	return new GraphQLError(
		message,
		undefined,
		undefined,
		undefined,
		undefined,
		originalError,
		status
			? {
					statusCode: status,
					http: { status },
				}
			: undefined,
	);
};
